import { API } from '../../core/http/api'

function parseActivityFromAPI (item) {
  return {
    boxId: item.activity.boxes && item.activity.boxes[0] && item.activity.boxes[0].boxid,
    messageId: item.activity.message?.id,
    title: item.activity.boxes && item.activity.boxes[0] && item.activity.boxes[0].boxname,
    summary: item.activity.log,
    id: item.id,
    date: item.createdAt, // .replace('T', ' ').replace('Z', ''),
    dateRaw: item.createdAt, // .replace('T', ' ').replace('Z', ''),
    visible: true,
    rawData: item.activity,
    thread: item.activity.thread,
  }
}

export const getUserActivities = async (page = 0, filter = 'all') => {
  const res = await API.get(`activities?filter=${filter}&page=${page}`)
  if (res.status === 200) {
    const serializedActivities = res.data.results?.map((activity) => parseActivityFromAPI(activity))
    return serializedActivities || []
  } else if (res.status === 401 && !(process.env.TEST_API || process.env.TEST)) {
    window.location.reload()
    window.localStorage.clear()
  }
}

export const getLastUserActivity = async () => {
  const res = await API.get('activities?limit=1')

  if (res.status === 200) {
    const serializedActivities = res.data.results?.map((activity) => parseActivityFromAPI(activity))
    return {
      results: serializedActivities || []
    }
  } else if (res.status === 401 && !(process.env.TEST_API || process.env.TEST)) {
    window.localStorage.clear()
    window.location.reload()
  }
}
